<template>
  <div id="app">


    <van-overlay :show="$store.state.loading">
      <van-loading style="margin-top:48vh;" size="24px">加载中...</van-loading>
    </van-overlay>
    <!--<router-view/>-->
    <keep-alive>
      <!--// 将需要缓存得页面写在keep-alive里面-->
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <!--// 不需要缓存得页面写在外面-->
    <router-view v-if="!$route.meta.keepAlive"/>

  </div>
</template>
<script>
  const html5QrCode = new Html5Qrcode("reader");
export default {
  name: 'App',
  data () {
    return {
      lastMessage:null,
      codesFound:0,
      sysMessage:''

    }
  },
  created () {
    let that=this;
    document.addEventListener('plusready', function() {
        console.log("所有plus api都应该在此事件发生后调用，否则会出现plus is undefined。")
        // 虚拟状态栏
        plus.webview.currentWebview().setStyle({
            statusbar: {
              background: '#ffffff'
            },
            top: 0,
            bottom: 0
        });
        // const path=that.$route.path
        // const paths=['/login','/homeView']
        // console.log("当前路径："+path);
        // if(paths.indexOf(path)==-1){
            
        // }
    });
  },
  mounted () {
  },
  methods:{
    qrStop(str){
      let vm = this
      html5QrCode.stop().then(ignore => {
        // QR Code scanning is stopped. 停止扫描二维码。
        vm.sysMessage = str
        console.log(vm.sysMessage )
//                return
      }).catch(err => {
        // Stop failed, handle it.  停止失败，处理它。
        console.log('stop err')
      });
        console.log('qrStop1',st)
//      html5QrCode.stop().then(ignore => {
//        // QR Code scanning is stopped. 停止扫描二维码。
//      }).catch(err => {
//        // Stop failed, handle it.  停止失败，处理它。
//      });
    },
    getCameras(){
      let vm = this
      const config = { fps: 10, qrbox: 250 };
      Html5Qrcode.getCameras().then(devices => {
        /**
         * devices would be an array of objects of type:
         * { id: "id", label: "label" }
         */
        if (devices && devices.length) {
          var cameraId = devices[0].id;
//          html5QrCode.start({ deviceId: { exact: cameraId} }, config, message => {
//            /* handle success */
//            console.log('message',message)
//          });
          html5QrCode.start({ facingMode: "environment" }, config,
            qrCodeSuccessCallback => {
            /* handle success */
            console.log('Success',qrCodeSuccessCallback)
              vm.sysMessage = qrCodeSuccessCallback
                vm.qrStop(qrCodeSuccessCallback)
          },
            OverconstrainedError => {
              console.log('Error',OverconstrainedError)
            });
          // .. use this to start scanning.
        }
      }).catch(err => {
        // handle err
      });



    },
  }
}
</script>

<style lang="less">
  @import './assets/pulice.less';
  body{
    margin:0;
  }
  #app {
    text-align: center;
    background: rgba(248,248,250,1);
    font-size: 14px;
    /*height: 100%;*/
    color: #2c3e50;
  }
  .modalStyle{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    /*height: 100vh;*/
    overflow: hidden;
  }

  #reader {
    width: 640px;
  }
  @media(max-width: 600px) {
    #reader {
      width: 300px;
    }
  }
  .empty {
    display: block;
    width: 100%;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue